module.exports = __webpack_public_path__ + "static/media/probe-tubes.b652c48d.png";